import {AnswerDto} from '../../../models/dtos/answer.dto';
import axios from '../../../utilities/axios';

export const getAnswerStatusRequest = async (answerId: number): Promise<AnswerDto> => {
  try {
    const response = await axios.get<AnswerDto>(
      `${process.env.REACT_APP_BASE_URL}/answers/${answerId}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};
